<app-back-nav class="d-lg-none d-flex"></app-back-nav> 
<div id="bighome" class="wrapper wrapper_lg air air_horz">
    <div class="row">
        <div class="col-lg-8 l-white">  
            <div class="login ml-lg-10 mt-lg-10">
                <div class="flex-column">
                	<div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->
                	<div class="row mt-8 d-none d-lg-flex ml-1"><!-- ROW -->
	                   <div class="col-md-9">
	                        <button class="btn btn-primary mt-3">Create Company Profile</button>
	                         <button class="btn btn-outline-primary mt-3"  routerLink="/proform">Create Professional Profile</button>
	                    </div>
	                   <div class="col-md-3">&nbsp;</div> 
	                </div>
	                <div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->
                    <div class="row mt-8 ml-1"><!-- ROW -->                    
	                    <div class="col-md-9">
	                       <div class="form-group">
	                       		<img src="{{office.Image}}" id="Image" style="max-height:200;max-width: auto">
	                       		<label for="profimage">Profile Image (2 Mb max)</label>
	                       		<input type="file" name="profimage" class="form-control" id="profimage" (change)="loadFile($event)">
						   </div>
	                    </div>
	                    <div class="col-md-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<!--<div class="row mt-8 ml-1"> ROW
	                    <div class="col-md-9">
	                       <div class="form-group">
	                       		<label for="company">Company (DBA)</label>
	                       		<input type="text" name="address" class="form-control" id="company" placeholder="Dental Co.">
	                       		<small class="errormsg" id="company_error">Company is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row ml-1"><!-- ROW -->
	                    <div class="col-md-6">
	                       <div class="form-group">
	                       		<label for="name">Practice Name</label>
	                       		<input type="text" name="name" class="form-control" id="name" [(ngModel)]="office.Name">
	                       		<small class="errormsg" id="Name_error">Practice is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="years">Open Since</label>
	                       		<select class="form-control" name="years" id="years" [(ngModel)]="office.Years">
									<option *ngFor="let year of years" value="{{year}}">{{year}}</option>
						        </select>
	                       		<small class="errormsg" id="Years_error">Years established is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
	                </div><!-- END ROW -->
	                <div class="row mt-8 ml-1"><!-- ROW -->
	                    <div class="col-md-9">
	                       <div class="form-group">
	                       		<label for="contact">Contact Name</label>
	                       		<input type="text" name="address" class="form-control" id="contact" [(ngModel)]="office.Contact">
	                       		<small class="errormsg" id="Contact_error">Contact name is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row mt-8 ml-1"><!-- ROW -->	                	
	                    <div class="col-md-5">
	                       <div class="form-group">
	                       		<label for="officeTel">Office Telephone</label>
	                       		<input type="text" name="officeTel" class="form-control" id="officeTel"  [(ngModel)]="office.Telephone">
	                       		<small class="errormsg" id="Telephone_error">Office telephone is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="mobile">Mobile (optional)</label>
	                       		<input type="text" name="mobile" class="form-control" id="mobile" [(ngModel)]="office.Mobile">
	                       		<small class="errormsg" id="Mobile_error">Mobile is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row mt-8 ml-1"><!-- ROW -->
						<div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="officeAddress">Contact Email</label>
	                       		<input type="email" name="contactmail" class="form-control" id="contactmail"  [(ngModel)]="office.Email">
	                       		<small class="errormsg" id="Email_error">Contact email is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-5">
	                       <div class="form-group">
	                       		<label for="officeAddress">Office Address</label>
	                       		<input type="text" name="officeAddress" class="form-control" id="officeAddress"  [(ngModel)]="office.Address">
	                       		<small class="errormsg" id="Address_error">Office Address is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row ml-1"><!-- ROW -->
						  <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="City">City</label>
	                       		<input type="text" name="city" class="form-control" id="city" [(ngModel)]="office.City">
	                       		<small class="errormsg" id="City_error">City is mandatory</small>
						   </div>
	                    </div>	                   
	                    <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="state">State</label>
	                       		<select class="form-control" name="state" id="state" [(ngModel)]="office.State">
									<option value="AL">Alabama</option>
						            <option value="AK">Alaska</option>
						            <option value="AZ">Arizona</option>
						            <option value="AR">Arkansas</option>
						            <option value="CA">California</option>
						            <option value="CO">Colorado</option>
						            <option value="CT">Connecticut</option>
						            <option value="DE">Delaware</option>
						            <option value="DC">District Of Columbia</option>
						            <option value="FL" selected>Florida</option>
						            <option value="GA">Georgia</option>
						            <option value="HI">Hawaii</option>
						            <option value="ID">Idaho</option>
						            <option value="IL">Illinois</option>
						            <option value="IN">Indiana</option>
						            <option value="IA">Iowa</option>
						            <option value="KS">Kansas</option>
						            <option value="KY">Kentucky</option>
						            <option value="LA">Louisiana</option>
						            <option value="ME">Maine</option>
						            <option value="MD">Maryland</option>
						            <option value="MA">Massachusetts</option>
						            <option value="MI">Michigan</option>
						            <option value="MN">Minnesota</option>
						            <option value="MS">Mississippi</option>
						            <option value="MO">Missouri</option>
						            <option value="MT">Montana</option>
						            <option value="NE">Nebraska</option>
						            <option value="NV">Nevada</option>
						            <option value="NH">New Hampshire</option>
						            <option value="NJ">New Jersey</option>
						            <option value="NM">New Mexico</option>
						            <option value="NY">New York</option>
						            <option value="NC">North Carolina</option>
						            <option value="ND">North Dakota</option>
						            <option value="OH">Ohio</option>
						            <option value="OK">Oklahoma</option>
						            <option value="OR">Oregon</option>
						            <option value="PA">Pennsylvania</option>
						            <option value="RI">Rhode Island</option>
						            <option value="SC">South Carolina</option>
						            <option value="SD">South Dakota</option>
						            <option value="TN">Tennessee</option>
						            <option value="TX">Texas</option>
						            <option value="UT">Utah</option>
						            <option value="VT">Vermont</option>
						            <option value="VA">Virginia</option>
						            <option value="WA">Washington</option>
						            <option value="WV">West Virginia</option>
						            <option value="WI">Wisconsin</option>
						            <option value="WY">Wyoming</option>
	                       		</select>
	                       		<small class="errormsg" id="State_error">State is mandatory</small>
						   </div>
	                    </div>
	                     <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="zip">Zip</label>
	                       		<input type="text" name="zip" class="form-control" id="zip" [(ngModel)]="office.Zip">
	                       		<small class="errormsg" id="Zip_error">Zip is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
	                </div><!-- END ROW -->
	                <div class="row ml-1"><!-- ROW -->
	                    <div class="col-md-5">
	                       <div class="form-group">
	                       		<label for="email">Email <small>(to be used as username)</small></label>
	                       		<input type="email" name="email" class="form-control" id="email" [(ngModel)]="user.email">
	                       		<small class="errormsg" id="email_error">Email is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="password">Password</label>
	                       		<input type="password" name="lastname" class="form-control" id="password"  [(ngModel)]="user.password">
	                       		<small class="errormsg" id="password_error">Should have at least 8 characters</small>
						   </div>
	                    </div>
	                    <div class="col-md-3 col-xs-0">&nbsp;</div> 
	                </div><!-- END ROW -->
	                <div class="row ml-1"><!-- ROW -->                    
	                    <div class="col-md-9">
	                       <div class="form-group">
	                       		<label for="services">Services and Specialties</label>
	                       		<textarea rows="5" name="services" class="form-control" id="services" [(ngModel)]="office.Services"></textarea>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					 <div class="row ml-1" *ngIf="isAdmin"><!-- ROW -->                    
	                    <div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="userType">Type of user</label>
	                       		<select name="FkType" id="FkType" [(ngModel)]="user.FkType" class="form-control">
	                       			<option value="2">Office</option>
	                       			<option value="3">Local admin</option>
	                       		</select>
						   </div>
	                    </div>
	                     <div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="PkOrganization">Organization</label>
	                       		<select name="PkOrganization" id="PkOrganization" [(ngModel)]="PkOrganization" class="form-control">
	                       			<option>Select ...</option>
	                       			<option *ngFor="let item of institutions" value="{{item.PkInstitution}}" [selected]="item.FkUser==user.PkUser">{{item.ShortName}}</option>
	                       		</select>
						   </div>
	                    </div>
	                    <div class="col-3">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row mt-8">
						<div class="flex-column justify-content-center ml-4 ml-lg-5 mr-4">
							<small class="errormsg">{{generalError}}</small>
							<div id="c-alerts__area"></div>
							<button class="btn w-100 btn-large btn-secondary" (click)="save()">{{submitmsg}}</button>						
							<p><small class="text-muted">By clicking this button you agree to TransForma's <a href="javascript:void(0)">Policy and terms of use</a></small></p>
		              </div>
					</div> <!-- separa -->
					<div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->
                </div>
            </div>
        </div>
        <div class="flex-column col-lg-4 l-grey d-none d-lg-flex">
           <app-login-form></app-login-form>
        <div>
    </div>
</div>
<app-footer class="d-none d-lg-block"></app-footer>